<template>
  <div class="newList container">
    <el-card class="box-card department-card">
      <div slot="header" class="clearfix">
        <span class="newList-title">新冠肺炎</span>
      </div>
      <div
        :span="12"
        v-for="(item, index) in list"
        :key="index"
        class="item text"
      >
        <p style="cursor: pointer" @click="check(item)">
          {{ index + 1 }}.{{ item.titleCN }}
        </p>
        <b v-if="item.authorCN">作者：{{ item.authorCN }}</b>
        <b v-else>作者：{{ item.authorEN }}</b>
        <p>发布时间： {{ item.updateTime }}</p>
      </div>
    </el-card>
    <div class="loadmore">
      <el-button plain class="loadmore-btn" @click="loadmore" :loading="loading"
        >加载更多</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      list: [],
      size: 10,
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.getSearchAllInfo();
  },
  methods: {
    // 获取新冠肺炎
    getSearchAllInfo() {
      let that = this;
      this.$axios({
        method: "get",
        url: "/api/covidFind?key=COVID-19&size=" + this.size,
      })
        .then(function (res) {
          that.newsList = res.data.data;
          that.list = that.newsList.slice(0, 10);
          that.loading = false;
        })
        .catch(function (thrown) {});
    },
    // 查看详情
    check(item) {
      this.$router.push({
        name: "Detail",
        params: {
          abstractCN: item.abstractCN,
          link: item.link,
        },
      });
    },
    loadmore() {
      this.loading = true;
      this.size += 10;
      if (this.size > this.newsList.length) {
        alert("已经获取全部");
      } else {
        this.list = this.newsList.slice(0, this.size);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.newList {
  margin-top: 30px;
  .newList-title {
    padding-left: 30px;
  }
  .item {
    padding-left: 30px;
  }
  .loadmore {
    text-align: center;
    padding: 30px 0;
    .loadmore-btn {
      width: 25%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newList.vue